import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";

// @material-ui/icons
import Assignment from "@mui/icons-material/Assignment";

// core components
import CardTable from "components/CardTable/CardTable";

// config Table
import { configTable } from "./tableData";

// Hooks
import { convertToMapById } from "helpers/convertToMap";
import { useSearch } from "hooks/useSearch";
import { useHistory } from "react-router-dom";


const tableKey = "brandsTable";

export default function BrandsPage() {
  // selectors
  const history = useHistory()
  const { configTables } = useSelector(({ search }) => search);
  const {brandName} = useSelector((state) => state.brandsReducer);
  const { buildTableConfig } = useSearch();
  
  const [mapBrands, setMapBrands] = useState([])
  
  const memoMapBrands = useCallback(() => {
    setMapBrands( convertToMapById(brandName) )
  }, [brandName])

  useEffect(() => {
    memoMapBrands()
  }, [memoMapBrands])

  useEffect(() => {
    !configTables[tableKey] && buildTableConfig(tableKey);
  }, [])


  const handleChangePage = (page) => {
    const newDirection = page ? page : "/admin/nuevo_marca";
    history.push(newDirection);
  };
  
  return (
    <CardTable
      hasHeader
      title="Marcas"
      icon={<Assignment />}
      data={mapBrands}
      tableKey={tableKey}
      columns={configTable}
      onChangePage={handleChangePage}
      resizable={false}
    />
  );
}
